export default "__VITE_PUBLIC_ASSET__0268635b__"